import {
  useOptionalPropsBridge,
  usePropsBridge,
} from '../../../context/PropsBridgeContext';
import type { PageRootBridgeProps } from '../types';

export const usePageBridgeProps = (): PageRootBridgeProps =>
  usePropsBridge<PageRootBridgeProps>();

export const useOptionalPageBridgeProps = (): PageRootBridgeProps | undefined =>
  useOptionalPropsBridge<PageRootBridgeProps>();
